(function () {
  class PawModifier extends PIXI.Container {
    constructor() {
      super();

      this.fadeMultiplierPanelOffTweenInfo = {};
      this.moveMultiplierPanelOffTweenInfo = {};
      this.moveMultiplierTextOffTweenInfo = {};

      this.swipeSounds = ['mouseSwipe1', 'mouseSwipe2', 'mouseSwipe3'];

      this.visible = false;
      gameData.pawModifier = this;
    }

    //////////////////////////////////////////////////
    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
      messageBus.subscribe('game:pawSlapModifier', (event) => {
        this.onPawSlapModifier(event);
      });
    }

    //////////////////////////////////////////////////
    onLayoutComplete() {
      this.baseName = this.name + ':';
      this.grabReferences();
      this.setupSpineAnims();
    }

    grabReferences() {
      this.hitAnim = resourceManager.get(this.baseName + 'hitAnim');
      this.hitAnim.gotoAndStop(0);
      this.hitAnim.visible = false;

      this.multiplierText = resourceManager.get(this.baseName + 'multiplierTextContainer:multiplierFrontTextL');
      this.multiplierText.visible = false;
      this.multiplierPanel = resourceManager.get(this.baseName + 'multiplierFront');
      this.multiplierPanel.visible = false;

      this.multiplierTextContainer = resourceManager.get(this.baseName + 'multiplierTextContainer');
      this.multiDisplayFrontMultiplierText = resourceManager.get('multiDisplay:multiplierDisplay:multiplierFrontTextL');
      this.multiDisplayFrontMultiplierPanel = resourceManager.get('multiDisplay:multiplierDisplay:multiplierFront');

      this.multiplierDisplay = resourceManager.get('multiDisplay:multiplierDisplay');
    }

    setupSpineAnims() {
      this.mouseSpineAnim = resourceManager.createObject('spine', 'mouseSpineAnim', this.baseName + 'mouseContainer', {
        name: 'Mouse',
        scaleX: 0.25,
        scaleY: 0.25,
        x: 0,
        y: 0,
      });

      this.mouseSpineAnim.visible = false;
      // this.mouseSpineAnim.play('Twitch', true, 0);

      this.pawSpineAnim = resourceManager.createObject('spine', 'pawSpineAnim', this.baseName + 'pawContainer', {
        name: 'paw_slap',
        scaleX: 0.5,
        scaleY: 0.5,
        x: 0,
        y: 0,
      });

      this.pawSpineAnim.visible = false;
    }

    async onPawSlapModifier(event) {
      event.join();

      // lets have a bit of a delay before we do anything
      await timerManager.delayAsync(1000);

      await this.doModifier(event.data.modifierData.multiplierBoostedTo);

      event.leave();
    }

    async doModifier(multiplierToGetTo) {
      this.visible = true;

      // so reels have stopped
      // before we process any wins

      // lets swap the multiplier panels over
      this.showOurMultiplierPanel();
      // we need to bring on the mouse
      await this.mouseEnters();

      await timerManager.delayAsync(1000);

      let moreBoostsToDo = false;
      do {
        moreBoostsToDo = false;

        const soundIndex = Math.floor(Math.random() * this.swipeSounds.length);
        soundManager.play(this.swipeSounds[soundIndex]);

        const pawSlapPromise = this.pawSlap();

        await timerManager.delayAsync(600);

        Utils.playMovieAsync(this.hitAnim);
        const jumpPromise = this.playMouseJump();
        const movePanelPromise = this.moveMultiplierPanelOff();
        const incrementMultiplierPromise = this.incrementMultiplier();
        await Promise.all([
          pawSlapPromise, //
          jumpPromise,
          movePanelPromise,
          incrementMultiplierPromise,
        ]);

        // slight delay between doing this again or exiting
        await timerManager.delayAsync(500);

        if (this.multiplierDisplay.multipliers[0] < multiplierToGetTo) {
          moreBoostsToDo = true;
        }
      } while (moreBoostsToDo === true);

      await this.mouseLeaves();

      this.showOriginalMultiplierPanel();

      this.visible = false;
    }

    async incrementMultiplier() {
      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      if (!this.multiplierDisplay.multiplierActive) {
        this.multiplierDisplay.openDoor(true, resolver);
      } else {
        // multiplier value to be passed isnt important
        this.multiplierDisplay.increaseMultiplier(0, true, resolver);
      }

      await promise;

      if (this.fadeMultiplierPanelOffTweenInfo.tween && this.fadeMultiplierPanelOffTweenInfo.tween.isActive()) {
        this.fadeMultiplierPanelOffTweenInfo.tween.totalProgress(1);
      }
      if (this.moveMultiplierPanelOffTweenInfo.tween && this.moveMultiplierPanelOffTweenInfo.tween.isActive()) {
        this.moveMultiplierPanelOffTweenInfo.tween.totalProgress(1);
      }
      if (this.moveMultiplierTextOffTweenInfo.tween && this.moveMultiplierTextOffTweenInfo.tween.isActive()) {
        this.moveMultiplierTextOffTweenInfo.tween.totalProgress(1);
      }

      this.showOurMultiplierPanel();
    }

    showOurMultiplierPanel(multiplier = this.multiplierDisplay.multipliers[0]) {
      this.multiplierText.setText(`X${multiplier}`);
      this.multiplierText.visible = true;
      this.multiplierPanel.visible = true;
      this.multiplierText.alpha = 1;
      this.multiplierPanel.alpha = 1;
      this.multiDisplayFrontMultiplierText.renderable = false;
      this.multiDisplayFrontMultiplierPanel.renderable = false;
    }

    showOriginalMultiplierPanel() {
      this.multiplierText.visible = false;
      this.multiplierPanel.visible = false;
      this.multiDisplayFrontMultiplierText.renderable = true;
      this.multiDisplayFrontMultiplierPanel.renderable = true;
    }

    async mouseEnters() {
      soundManager.play('mouseIn');

      this.mouseSpineAnim.spineObject.state.clearTracks();
      this.mouseSpineAnim.spineObject.state.clearListeners();
      this.mouseSpineAnim.spineObject.skeleton.setToSetupPose();
      this.mouseSpineAnim.visible = true;
      this.mouseSpineAnim.alpha = 0;

      const entryPromise = Utils.playSpineAsync('Entry', this.mouseSpineAnim, false);
      await Utils.tweenFromToAsync(
        this.mouseSpineAnim,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.5,
        }
      );

      await entryPromise;

      this.mouseSpineAnim.spineObject.state.clearListeners();
      this.mouseSpineAnim.play('Twitch', true, 0);
    }

    async mouseLeaves() {
      soundManager.play('mouseOut');

      const exitPromise = Utils.playSpineAsync('Exit', this.mouseSpineAnim);
      await Utils.tweenFromToAsync(
        this.mouseSpineAnim,
        {
          alpha: 1,
        },
        {
          alpha: 0,
          delay: 0.25,
          duration: 0.5,
        }
      );

      await exitPromise;

      this.mouseSpineAnim.spineObject.state.clearTracks();
      this.mouseSpineAnim.spineObject.state.clearListeners();
      this.mouseSpineAnim.spineObject.skeleton.setToSetupPose();
      this.mouseSpineAnim.stop();
    }

    async playMouseJump() {
      await Utils.playSpineAsync('Jump', this.mouseSpineAnim, false);
      this.mouseSpineAnim.spineObject.state.clearListeners();
      this.mouseSpineAnim.play('Twitch', true, 0);
    }

    async pawSlap() {
      await Utils.playSpineAsync('Paw_Slap', this.pawSpineAnim);
    }

    async moveMultiplierPanelOff() {
      const fadePromise = Utils.tweenFromToAsync(
        [this.multiplierText, this.multiplierPanel], //
        { alpha: 1 },
        { alpha: 0, duration: 0.3 },
        this.fadeMultiplierPanelOffTweenInfo
      );

      const movePanelPromise = Utils.tweenFromToAsync(
        this.multiplierPanel, //
        {
          x: this.multiplierPanel.x,
        },
        {
          x: this.multiplierPanel.x - 100,
          duration: 0.3,
        },
        this.moveMultiplierPanelOffTweenInfo
      );

      const moveTextPromise = Utils.tweenFromToAsync(
        this.multiplierText, //
        {
          x: this.multiplierText.x,
        },
        {
          x: this.multiplierText.x - 100,
          duration: 0.3,
        },
        this.moveMultiplierTextOffTweenInfo
      );

      await Promise.all([fadePromise, movePanelPromise, moveTextPromise]);

      const textPos = layoutController.getCurrentPosition(
        this.baseName + 'multiplierTextContainer:multiplierFrontTextL'
      );
      const panelPos = layoutController.getCurrentPosition(this.baseName + 'multiplierFront');
      this.multiplierText.x = textPos.x;
      this.multiplierPanel.x = panelPos.x;
    }

    async playMovieAsync(movie, hideWhenFinished = true) {
      movie.visible = true;
      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });
      movie.gotoAndPlay(0);
      movie.onComplete = () => {
        resolver();
      };
      await promise;
      if (hideWhenFinished) {
        movie.visible = false;
      }
    }

    async playSpineAsync(animName, spineAnim, hideWhenFinished = true) {
      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      spineAnim.visible = true;
      spineAnim.spineObject.state.timeScale = 1;
      spineAnim.spineObject.state.clearListeners();

      spineAnim.play(animName, false, 0, () => {
        resolver();
      });

      await promise;

      if (hideWhenFinished) {
        spineAnim.visible = false;
      }
    }
  }

  //////////////////////////////////////////////////
  create = function (json) {
    return new PawModifier();
  };

  //////////////////////////////////////////////////
  initialise = function (json, container, resources) {
    container.initialise();
  };

  //////////////////////////////////////////////////
  getFilesRequired = function (json) {
    return ['', ''];
  };

  resourceManager.registerObjectType('PawModifier', create, initialise, getFilesRequired);
})();
